{
  "name": "meta-scan",
  "version": "0.11.1",
  "description": "A lightweight, client-side JavaScript tool for extracting and visualizing webpage metadata",
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "browser": "dist/auto.global.js",
  "scripts": {
    "dev": "npm-run-all --parallel dev:css dev:tsup serve",
    "dev:css": "postcss ./src/ui/styles.css -o ./src/ui/styles.processed.css --watch",
    "dev:tsup": "NODE_ENV=development tsup --watch",
    "build": "npm run build:css && NODE_ENV=production tsup",
    "build:css": "postcss ./src/ui/styles.css -o ./src/ui/styles.processed.css",
    "test": "echo \"No tests yet\"",
    "serve": "serve",
    "canary": "pnpm run build && npx auto canary --force"
  },
  "files": [
    "dist",
    "README.md",
    "LICENSE"
  ],
  "keywords": [
    "metadata",
    "seo",
    "opengraph",
    "extraction",
    "visualization"
  ],
  "author": "Your Name",
  "license": "MIT",
  "devDependencies": {
    "@auto-it/all-contributors": "^11.3.0",
    "@auto-it/conventional-commits": "^11.3.0",
    "@auto-it/npm": "^11.3.0",
    "@auto-it/omit-commits": "^11.3.0",
    "@auto-it/omit-release-notes": "^11.3.0",
    "@auto-it/released": "^11.3.0",
    "auto": "^11.3.0",
    "autoprefixer": "^10.4.16",
    "clsx": "^2.1.1",
    "npm-run-all": "^4.1.5",
    "postcss": "^8.4.31",
    "postcss-cli": "^10.1.0",
    "tailwind-merge": "^3.0.2",
    "tailwindcss": "^3.3.5",
    "tsup": "^7.2.0",
    "typescript": "^5.2.2"
  },
  "dependencies": {
    "preact": "^10.19.2",
    "serve": "^14.2.4"
  }
}
